import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../cn.js';
export function Spinner({ className }) {
    return (_jsxs("svg", { "aria-hidden": "true", className: cn('h-5 w-5 animate-spin text-on-surface-variant', className), viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [_jsx("circle", { cx: "12", cy: "12", r: "10", className: "opacity-25" }), _jsx("path", { d: "M4 12a8 8 0 018-8", className: "opacity-75" })] }));
}
//# sourceMappingURL=Spinner.js.map